import React, { memo } from 'react';

function Currency({ color = '#335B70', ...props }) {
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13 1h-2v2c-2.932.274-5 2.774-5 5.083 0 3.665 2.673 4.671 5.634 5.42 1.435.362 2.276.769 2.753 1.185.76.663.727 2.119 0 2.812-.422.403-1.17.842-2.456.842-1.354 0-2.992-.473-2.992-2.31L8.97 15H6l-.032 1.033c0 2.837 2.406 4.622 5.032 4.931V23h2v-2c2.502-.232 5-2.612 5-5.31 0-5.167-5.319-4.393-8.234-6.506-.907-.658-.965-2.174.01-2.807.5-.324 1.248-.64 2.188-.64 1.052 0 2.949.51 3.011 2.346V9H18v-.917C18 5.42 15.228 3.052 13 3V1z"
                fill={color}
            />
        </svg>
    );
}

export default memo(Currency);
